import React, { Component } from 'react';

import { connect } from 'react-redux';
import { reduxForm, FormSection } from "redux-form";
import { compose } from 'redux';

// vendor
import smoothscroll from 'smoothscroll';

// components
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";


class Membership extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step1Done: false,
            step2Done: false,
            step3Done: false,
            step4Done: false,
            loaded: true
        };

        this.handleNextStep1 = this.handleNextStep1.bind(this);
        this.handleNextStep2 = this.handleNextStep2.bind(this);
        this.handleNextStep3 = this.handleNextStep3.bind(this);
    }

    handleNextStep1() {
        smoothscroll(this.step2, 600);
        this.setState({ step1Done: true });
    }

    handleNextStep2() {
        smoothscroll(this.step3, 600);
        this.setState({ step2Done: true });
    }

    handleNextStep3() {
        smoothscroll(this.step4, 600);
        this.setState({ step3Done: true });
    }

    render() {
        return (
            <main className="content">
                <section className="memberShipSec">
                    <div className="container">
                        <header className="mainHeading text-center">
                            <h2>Membership</h2>
                        </header>

                        {/* Steps */}
                        <div className="stepSec">
                            <form action="https://wwd1.wewhodo.com/membership" onSubmit={this.props.handleSubmit}>
                                {/* Step 1 - Skills & competency */}
                                <FormSection name="Step1">
                                    <Step1
                                        onClickNext={this.handleNextStep1}
                                        className={this.state.step1Done} />
                                </FormSection>

                                {/* Step 2 - Profile questions */}
                                <FormSection name="Step2">
                                    <section ref={node => {
                                        this.step2 = node;
                                    }}>
                                        <Step2
                                            onClickNext={this.handleNextStep2}
                                            classDone={this.state.step1Done}
                                            className={this.state.step2Done}
                                            invalidSteps={this.props.invalid} />
                                    </section>
                                </FormSection>

                                {/* Step 3 - Personal details */}
                                <FormSection name="Step3">
                                    <section ref={node => {
                                        this.step3 = node;
                                    }}>
                                        <Step3
                                            onClickNext={this.handleNextStep3}
                                            classDone={this.state.step1Done && this.state.step2Done}
                                            className={this.state.step3Done}
                                            invalidSteps={this.props.invalid} />
                                    </section>
                                </FormSection>

                                {/* Step 4 - Final form submission */}
                                <FormSection name="Step4">
                                    <section ref={node => {
                                        this.step4 = node;
                                    }}>
                                        <Step4
                                            {...this.props}
                                            classDone={this.state.step1Done && this.state.step2Done && this.state.step3Done}
                                            className={this.state.step4Done}
                                            invalidSteps={this.props.invalid} />
                                    </section>
                                </FormSection>
                            </form>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}

const checkSkilles = skills => !!skills.numberOfSelectedCols;

export default compose(
    reduxForm({
        form: 'membership',
        onSubmit: function (values, dispatch, props) {
            if (!checkSkilles(values.Step1.skills)) {
                return alert("You skipped skills and competency!");
            }
            let result = Object.assign({}, values.Step1.skills, values.Step2, values.Step3, values.Step4);
            let body = JSON.stringify(result);

            let overlay = document.createElement('DIV');
            overlay.id = 'loading';
            overlay.className = 'loading';
            overlay.innerHTML = '<div><div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';

            document.body.appendChild(overlay);

            let files = document.getElementsByName('Step4.cvfile')[0].files;

            let form = new FormData();
            form.append('data', body);

            if(files.length > 0) {
                form.append('cvs', files[0], files[0].name);
            }

            fetch('https://wwd1.wewhodo.com/community_membership/creative', {
                method: 'POST',
                body: form
            })
            .then(
                (response) => {
                    if(response.status == 200) {
                        window.location = 'https://content.wewhodo.com/thank-you/';
                    }
                    else if(response.status == 400) {
                        let overlay = document.getElementById('loading');
                        if(overlay) document.body.removeChild(overlay);
                        response.json().then(
                                (data) => {
                                    let keys = Object.keys(data);
                                    if(keys.length > 0) {
                                        alert(data[keys[0]]);
                                    }
                                }
                            );
                    }
                    else
                    {
                        let overlay = document.getElementById('loading');
                        if(overlay) document.body.removeChild(overlay);
                        alert('Unknown error');
                    }
                },
                (err) => {
                    let overlay = document.getElementById('loading');
                    if(overlay) document.body.removeChild(overlay);
                    console.log(err);
                }
            )

            return true;
        }
    }),
    connect(
        state => {
            let invalid = [];
            if (state.form.membership && state.form.membership.syncErrors) {
                invalid = Object.keys(state.form.membership.syncErrors)
            }
            return { invalid };
        }
    ),
)(Membership)



// WEBPACK FOOTER //
// ./src/components/Membership/index.js